import {MODULE_MAPPING} from "@/constants";
import useListingFunctions from "@/composables/useListingFunctions";

export default function usePermissions() {
    const rfp_permission = {
        dashboard: {
            module: 1,
        },
        rfp: {
            module: 1,
            view: 1,
            view_all: 0,
            view_specific: 0,
            create: 0                                                                                                                             ,
            update: 0,
            cancel: 0,
            note: 0,
            approve: 0
        },
        signatories: {
            module: 1,
            view: 1,
            create: 0,
            update: 0,
            delete: 0,
        },
        users: {
            module: 1,
            view: 1,
            create: 0,
            update: 0,
            reset: 0,
            permission: 0
        }
    }

    const specific_param = {
            department: '',
            branches: []
    }

    function canBeAccessed(module, action = null) {
        let modules = JSON.parse(localStorage.getItem('module_perms')) ?? []
        let decoded_modules = useListingFunctions().base64decoding(modules)
        decoded_modules = JSON.parse(decoded_modules)

        if(Object.keys(decoded_modules).length < 1) return

        if(decoded_modules[module]) {
            if(action === null) return true
            if(decoded_modules[module].includes(action)) return true
        }

        return false
    }

    function nearestAccessibleModule() {
        let modules = JSON.parse(localStorage.getItem('module_perms')) ?? []
        let module = null

        let decoded_modules = useListingFunctions().base64decoding(modules)
        decoded_modules = JSON.parse(decoded_modules)

        if(Object.keys(decoded_modules).length >= 1) {
            for(const key of Object.keys(MODULE_MAPPING)) {
                if(decoded_modules[MODULE_MAPPING[key]['code']]) {
                    module = key
                    break
                }
            }
        }

        return module
    }

    return {
        canBeAccessed,
        rfp_permission,
        specific_param,
        nearestAccessibleModule
    }
}